import React, { useState, useEffect, useRef } from "react";
import Constants from "../constants/Constants";
import "../css/reasons.css";
const POPUP_CLASS = "show_popup";
const ReasonsForCanceling = ({
  model,
  i,
  dispatch,
  user,
  setIsCanceling,
  setShowReasons,
  setError
}) => {
  const [selectedReasons, setSelectedReasons] = useState(0);
  const [customReason, setCustomReason] = useState("");
  const [secondQuestion, setSecondQuestion] = useState("");
  const [otherError, setOtherError] = useState(false);
  const [isCanceling, setLocalIsCanceling] = useState(false);
  const [isOtherQuestion, setIsOtherQuestion] = useState(false);
  const [reasons, setReasons] = useState([]);
  const reasonRef = useRef(null);
  useEffect(() => {
    if (isOtherQuestion) {
      reasonRef.current.focus();
    }
  }, [isOtherQuestion]);
  const handleCancelMembership = () => {
    if (isCanceling) {
      return;
    }
    setLocalIsCanceling(true);
    let formData = new FormData();
    formData.append("m", user.memID);
    formData.append("siteid", user.siteid);
    formData.append("reason", selectedReasons);
    formData.append("custom", customReason);
    fetch(`${Constants.API}cancelmembership.php`, {
      credentials: "include",
      method: "POST",
      body: formData
    })
      .then(res => res.json())
      .then(res => {
        if (!("error" in res)) {
          setIsCanceling(true);
          setLocalIsCanceling(false);
          document.body.classList.remove(POPUP_CLASS);
          setShowReasons(false);
          dispatch({
            type: "setMemToExpire",
            payload: parseInt(i),
            timeVal: 1559494639
          });
        } else {
          setError(
            "Please contact support something went wrong...  If you already cancelled through your biller this message can be ignored.  Your status will be updated over then next 3 - 4 hours."
          );
          setLocalIsCanceling(false);
          document.body.classList.remove(POPUP_CLASS);
          setShowReasons(false);
        }
      });
  };
  const handleOtherSave = () => {
    if (customReason.length > 4) {
      setIsOtherQuestion(false);
    } else {
      setOtherError(true);
    }
  };
  const handleCancelReason = id => {
    setSelectedReasons(id);
    setIsOtherQuestion(true);
  };
  const shuffle = array => {
    var currentIndex = array.length,
      temporaryValue,
      randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {
      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;

      // And swap it with the current element.
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }

    return array;
  };
  useEffect(() => {
    fetch(`${Constants.API}cancel_reasons.php`, {
      credentials: "include"
    })
      .then(res => res.json())
      .then(res => {
        setReasons(shuffle(res));
      });
  }, []);
  return (
    <div className="popup">
      <div className="popup_modal">
        <button
          type="button"
          className="popup_close"
          id="popup_close"
          onClick={() => {
            document.body.classList.remove(POPUP_CLASS);
            setShowReasons(false);
            setIsOtherQuestion(false);
          }}
        >
          <i className="icon-close" />
        </button>
        {selectedReasons && !isOtherQuestion ? (
          <div
            className={isCanceling ? "content cancel-processing" : "content"}
          >
            <strong>{model.site_name}</strong> Will Miss You!
            <button
              type="button"
              className="button buttonChoice reasonsBTN"
              onClick={handleCancelMembership}
            >
              Cancel Membership
              <div className="nk-spinner" />
            </button>
          </div>
        ) : (
          <div className="content">
            {isOtherQuestion ? (
              <div className="subQuestion">{secondQuestion}</div>
            ) : (
              <div>
                <strong>Why</strong> are you canceling your{" "}
                <strong>{model.site_name}</strong> membership?
                <small>(select one)</small>
              </div>
            )}

            {otherError ? (
              <small className="error">
                **Please provide a reason (at least 4 char)
              </small>
            ) : null}
          </div>
        )}

        <div className={isOtherQuestion ? "bottom limit" : "bottom"}>
          {isOtherQuestion ? (
            <div className="otherReason">
              <h5 className="reasonHeader">
                <small>
                  (<strong>min</strong> 4char, <strong>max</strong> 35char)
                </small>
              </h5>
              <input
                type="text"
                ref={reasonRef}
                className="reasonInput"
                value={customReason}
                onChange={e => setCustomReason(e.target.value)}
              />
              <div className="saveContain">
                <span className="saveReason" onClick={handleOtherSave}>
                  Save
                </span>
              </div>
            </div>
          ) : (
            reasons.map(reason => (
              <div
                key={`rid${reason.id}`}
                className={
                  reason.id === selectedReasons
                    ? "aReason selected"
                    : selectedReasons
                    ? "aReason noSelected"
                    : "aReason"
                }
                onClick={() => {
                  handleCancelReason(reason.id);
                  setSecondQuestion(reason.sub_question);
                }}
              >
                {reason.id === "5" && customReason && selectedReasons === "5"
                  ? customReason
                  : reason.the_reason}
              </div>
            ))
          )}
          <div className="hide_link">
            <a href="https://addfriends.com/contact-us">Contact support</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReasonsForCanceling;
